import PropTypes from 'prop-types';

const paginationShape = PropTypes.shape({
  currentPage: PropTypes.number.isRequired,
  from: PropTypes.number.isRequired,
  to: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  totalRecords: PropTypes.number.isRequired,
});

export default paginationShape;
